export default __webpack_public_path__ + "static/media/ci6.6a4baa7b.jpg";